import { render, staticRenderFns } from "./viewGroup.vue?vue&type=template&id=3882a60e&scoped=true&"
import script from "./viewGroup.vue?vue&type=script&lang=js&"
export * from "./viewGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882a60e",
  null
  
)

export default component.exports